// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/IdentityUserSearchBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/IdentityUserSearchBy.proto.
 */
export const file_Enumerations_IdentityUserSearchBy: GenFile = /*@__PURE__*/
  fileDesc("CidFbnVtZXJhdGlvbnMvSWRlbnRpdHlVc2VyU2VhcmNoQnkucHJvdG8SGnRpbWVfdHJhY2tpbmcuZW51bWVyYXRpb25zKrYCChRJZGVudGl0eVVzZXJTZWFyY2hCeRItCiFJREVOVElUWV9VU0VSX1NFQVJDSF9CWV9URU5BTlRfSUQQABoGysfNDwEDEikKHUlERU5USVRZX1VTRVJfU0VBUkNIX0JZX0VNQUlMEAEaBsrHzQ8BBBItCiFJREVOVElUWV9VU0VSX1NFQVJDSF9CWV9VU0VSX05BTUUQAhoGysfNDwEGEi4KIklERU5USVRZX1VTRVJfU0VBUkNIX0JZX0ZJUlNUX05BTUUQAxoGysfNDwEHEi0KIUlERU5USVRZX1VTRVJfU0VBUkNIX0JZX0xBU1RfTkFNRRAEGgbKx80PAQgSNgoqSURFTlRJVFlfVVNFUl9TRUFSQ0hfQllfRVhURVJOQUxfUkVGRVJFTkNFEAUaBsrHzQ8BCkIoqgIlTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLkVudW1lcmF0aW9uc2IGcHJvdG8z", [file_Options_EnumValueOptions]);

/**
 * Determines which columns of an Identity user can be used for text search.
 *
 * @generated from enum time_tracking.enumerations.IdentityUserSearchBy
 */
export enum IdentityUserSearchBy {
  /**
   * Search through the tenant id of a user.
   *
   * @generated from enum value: IDENTITY_USER_SEARCH_BY_TENANT_ID = 0;
   */
  TENANT_ID = 0,

  /**
   * Search through the email address of a user.
   *
   * @generated from enum value: IDENTITY_USER_SEARCH_BY_EMAIL = 1;
   */
  EMAIL = 1,

  /**
   * Search through the user name of a user.
   *
   * @generated from enum value: IDENTITY_USER_SEARCH_BY_USER_NAME = 2;
   */
  USER_NAME = 2,

  /**
   * Search through the first name of a user.
   *
   * @generated from enum value: IDENTITY_USER_SEARCH_BY_FIRST_NAME = 3;
   */
  FIRST_NAME = 3,

  /**
   * Search through the last name of a user.
   *
   * @generated from enum value: IDENTITY_USER_SEARCH_BY_LAST_NAME = 4;
   */
  LAST_NAME = 4,

  /**
   * Search through the external reference text of a user.
   *
   * @generated from enum value: IDENTITY_USER_SEARCH_BY_EXTERNAL_REFERENCE = 5;
   */
  EXTERNAL_REFERENCE = 5,
}

/**
 * Describes the enum time_tracking.enumerations.IdentityUserSearchBy.
 */
export const IdentityUserSearchBySchema: GenEnum<IdentityUserSearchBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_IdentityUserSearchBy, 0);

